<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

        </div>

        <div class="contenido_">

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-1">
                        <h3>
                            Proveedores
                        </h3>
                    </div>

                    <div class="col-sm-8 mt-3">
                        <label for="" class="form-label">Nombre proveedor</label>
                        <input type="text" class="form-control form-control-sm" v-model="proveedor">
                    </div>

                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">NIT</label>
                        <input type="text" class="form-control form-control-sm" v-model="nit">
                    </div>

                    <div class="col-sm-7 mt-3">
                        <label for="" class="form-label">Teléfono</label>
                        <input type="number" class="form-control form-control-sm" v-model="telefono">
                    </div>

                    <div class="col-sm-2 mt-3">
                        <label for="" class="form-label">Días crédito</label>
                        <input type="number" class="form-control form-control-sm" v-model="dias_credito">
                    </div>

                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            v-if="permisos['proveedores']?.crear || datos_usuario.parametros.roles.includes('ROOT')"
                            @click="guardar_proveedores">Crear</button>
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            v-else disabled>Crear</button>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                            <thead>
                                <tr>
                                    <th style="width: 10%;text-align: center;">
                                        ID
                                    </th>
                                    <th style="width: 40%;">
                                        Nombre
                                    </th>
                                    <th style="width: 15%;text-align: center;">
                                        NIT
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        Teléfono
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        D.crédito
                                    </th>
                                    <th style="width: 15%;text-align: center;">
                                        ...
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in proveedores_" :key="index">
                                    <td style="text-align: center;">
                                        {{ item.id }}
                                    </td>
                                    <td>
                                        {{ item.nombre_proveedor }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.nit }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.telefono }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.dias_credito }}
                                    </td>
                                    <td style="text-align: center;">
                                        <b-button type="button" size="sm" style="font-size: 9px;margin-right: 5px;"
                                            variant="outline-dark" 
                                            v-if="permisos['proveedores']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')"
                                            @click="abrir_modal_actualizar_proveedor(item)">
                                            <i class="fas fa-pen"></i>
                                        </b-button>
                                        <b-button type="button" size="sm" style="font-size: 9px;margin-right: 5px;"
                                            variant="outline-dark" v-else disabled>
                                            <i class="fas fa-pen"></i>
                                        </b-button>

                                        <b-button type="button" size="sm" style="font-size: 9px;margin-right: 5px;"
                                            variant="outline-dark"
                                            v-if="permisos['proveedores']?.borrar || datos_usuario.parametros.roles.includes('ROOT')"
                                            @click="eliminar_proveedor(item)">
                                            <i class="fas fa-trash"></i>
                                        </b-button>
                                        <b-button type="button" size="sm" style="font-size: 9px;margin-right: 5px;"
                                            variant="outline-dark" v-else disabled>
                                            <i class="fas fa-trash"></i>
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>

        <Actualizar v-if="modal_actualizar_proveedor" :item="item" v-on:salir="cerrar_modal_actualizar_proveedor" />


    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import { minix, pregunta } from '../functions/alertas';
    import Actualizar from './Actualizar.vue'

    export default {
        name: 'MenuProveedores',
        computed: {
            ...mapState(['proveedores_', 'permisos', 'datos_usuario'])
        },
        components: {
            Actualizar
        },
        data() {
            return {
                proveedor: '',
                nit: '',
                telefono: '',
                dias_credito: 0,
                modal_actualizar_proveedor: false,
                item: {}
            }
        },
        methods: {
            async guardar_proveedores() {

                if (this.proveedor == '' || this.nit == '' || this.telefono == '') {

                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {


                    if (this.telefono.length != 8) {
                        minix({ icon: 'error', mensaje: 'El teléfono debe tener 8 dígitos', tiempo: 3000 })
                    } else {

                        let f = {
                            api: `proveedores`,
                            formulario: {
                                nombre_proveedor: this.proveedor.trim().toUpperCase(),
                                nit: this.nit,
                                telefono: this.telefono,
                                dias_credito: this.dias_credito == '' ? 0 : this.dias_credito
                            }
                        }

                        await this.guardar_data(f)
                        await this.obtener_proveedores()

                        this.proveedor = ''
                        this.nit = ''
                        this.telefono = ''
                        this.dias_credito = 0
                    }

                }


            },
            cerrar_modal_actualizar_proveedor() {
                this.modal_actualizar_proveedor = false
            },
            abrir_modal_actualizar_proveedor(item) {
                this.item = item
                this.modal_actualizar_proveedor = true
            },
            async eliminar_proveedor(item) {

                pregunta({ titulo: 'Seguro que deseas borrar registro?', texto: 'El registro se borrara permanentemente en 30 días', afirmacion: 'Si, borrar!' }, async (i) => {


                    if (i) {
                        let f = {
                            api: `proveedores/${item.documentId}`,
                            formulario: {
                                activo: false
                            }
                        }

                        await this.actualizar_data(f)
                        await this.obtener_proveedores()

                    }
                })

            },
            ...mapActions(['guardar_data', 'obtener_proveedores', 'actualizar_data'])
        }
    }
</script>

<style></style>